import {createActions} from 'client/framework';

export const resetPasswordActions = createActions(null, [
  'RESET_PASSWORD_RESET_STORE',
  'RESET_PASSWORD_SET_SHOW_TOAST',
  'RESET_PASSWORD_SET_PARAMETERS',
  'RESET_PASSWORD_SET_INPUT_STATE',
  'RESET_PASSWORD_VALIDATE_INPUT'
]);
